import React, { useEffect, useState, useRef } from "react";
import "./interestedsection.css";
import { Link } from "react-router-dom";
import { interested } from "../../services/api";
import AlertCustDialogBox from "../alertbox/AlertCustDialogBox";
import Alertbox from "../../components/alertbox/Alertbox";
const lady_img1 = require("../../assets/iiso-bg-removebg-preview.png");

function InterestedSectionMain(props) {
  const [alertToggleModal, setAlertToggleModal] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    country_code: "",
    email: "",
    destination: "",
    plan_stude: "",
    study_level: "",
    term_cond: false,
  });

  // const userDetails = useRef({
  //   destination: "",
  //   plan_stude: "",
  //   study_level: "",
  // });
  useEffect(() => {
    console.log(formData);
  }, [formData]);
  async function handleSubmit(e) {
    e.preventDefault();
    let response = await interested({
      first_name: formData.first_name,
      last_name: formData.last_name,
      mobile: formData.mobile,
      country_code: formData.country_code,
      email: formData.email,
      destination: formData?.destination,
      plan_stude: formData?.plan_stude,
      study_level: formData?.study_level,
      term_cond: formData.term_cond,
    });

    if (response === "success") {
      setFormData({
        first_name: "",
        last_name: "",
        mobile: "",
        country_code: "",
        email: "",
        destination: "",
        plan_stude: "",
        study_level: "",
        term_cond: false,
      });

      // setFormData({ email: "" });
      // setFormData({ destination: "" });
      // setFormData({ plan_stude: "" });
      // setFormData({ study_level: "" });
      setAlertToggleModal(true);
      setTimeout(() => {
        setAlertToggleModal(false);
      }, 2000);
    }
  }

  return (
    <section className="main_interested_section_container">
      <div className="under_main_interested_section_container">
        <div className="header_content_container_interested">
          <p className="title_text">INTERESTED IN STUDYING OVERSEAS?</p>
        </div>
        <div className="two_interested_section_container">
          <div className="first_interested_section_container">
            <div className="first_interested_form_container">
              <form onSubmit={handleSubmit}>
                <div className="first_input_container">
                  <input
                    type="name"
                    placeholder="First name"
                    id="f_name"
                    required
                    autoComplete="off"
                    className="first_name_input_container"
                    value={formData.first_name}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        first_name: e.target.value,
                      }))
                    }
                  />
                  <input
                    type="name"
                    required
                    placeholder="Last name"
                    id="l_name"
                    autoComplete="off"
                    className="sec_name_input_container"
                    value={formData.last_name}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        last_name: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="sec_input_container">
                  <input
                    type="email"
                    required
                    placeholder="Email address"
                    id="email"
                    autoComplete="off"
                    className="first_name_input_container"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        email: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="third_input_container">
                  <div className="third_select_box_container">
                    <input
                      type="text"
                      placeholder="Country Code"
                      id="code"
                      required
                      autoComplete="off"
                      className="first_name_input_container"
                      value={formData.country_code}
                      onChange={(e) =>
                        setFormData((preVal) => ({
                          ...preVal,
                          country_code: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <input
                    type="number"
                    placeholder="Mobile number"
                    id="m-number"
                    required
                    autoComplete="off"
                    className="sec_name_input_container"
                    value={formData.mobile}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        mobile: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="four_input_container">
                  <select
                    name="destination"
                    required
                    id="destination"
                    className="normal_select_box_container"
                    // selectValue={(e) => {
                    //   userDetails.current["destination"] = e;
                    // }}
                    value={formData.destination}
                    onChange={(e) => {
                      console.log(e);
                      setFormData((preVal) => ({
                        ...preVal,
                        destination: e.target.value,
                      }));
                    }}
                  >
                    <option value="">
                      Your preferred study destination? *
                    </option>

                    <option value="UK">UK</option>
                    <option value="USA">USA</option>
                    <option value="Canada">Canada</option>
                    <option value="Australia">Australia</option>
                    <option value="new zealand">New Zealand</option>
                    <option value="italy">Italy</option>
                    <option value="germany">Germany</option>
                    <option value="russia">Russia</option>
                    <option value="ukraine">Ukraine</option>
                    <option value="south korea">South Korea</option>
                    <option value="poland">Poland</option>
                    <option value="netherlands">Netherlands</option>
                    <option value="ireland">Ireland</option>
                    <option value="japan">Japan</option>
                    <option value="switzerland">Switzerland</option>
                    <option value="singapore">Singapore</option>
                    <option value="malaysia">Malaysia</option>
                    <option value="france">France</option>
                    <option value="sweden">Sweden</option>
                  </select>
                </div>

                <div className="four_input_container">
                  <select
                    name="education"
                    required
                    id="education"
                    className="normal_select_box_container"
                    value={formData.plan_stude}
                    onChange={(e) => {
                      console.log(e);
                      setFormData((preVal) => ({
                        ...preVal,
                        plan_stude: e.target.value,
                      }));
                    }}
                  >
                    <option value="">
                      How would you fund your education? *
                    </option>
                    <option value="Loan">Loan</option>
                    <option value="Sponsorship">Sponsorship</option>
                    <option value="Scholarships">Scholarships</option>
                    <option value="Personal funds">Personal funds</option>
                  </select>
                </div>

                <div className="four_input_container">
                  <select
                    name="study_level"
                    required
                    id="study_level"
                    className="normal_select_box_container"
                    value={formData.study_level}
                    onChange={(e) => {
                      console.log(e);
                      setFormData((preVal) => ({
                        ...preVal,
                        study_level: e.target.value,
                      }));
                    }}
                  >
                    <option value="">Preferred study level?*</option>
                    <option value="diploma">Diploma</option>
                    <option value="gcertificate">Graduate Certificate</option>
                    <option value="bachelors">Bachelors</option>
                    <option value="int_program">Integrated Programme</option>
                    <option value="masters">Masters</option>
                    <option value="phd">PHD</option>
                  </select>
                </div>

                <div className="check_box_container">
                  <input
                    type="checkbox"
                    required
                    id="check11"
                    name="check"
                    className="checkbox_input"
                    value={formData.term_cond}
                    onChange={(e) =>
                      setFormData((preVal) => ({
                        ...preVal,
                        term_cond: !formData.term_cond,
                      }))
                    }
                  />
                  <label htmlFor="check11" className="checkbox_label_text">
                    I agree to{" "}
                    <Link
                      to="/TermsAndConditions"
                      className="link_text_terms_text"
                    >
                      Terms & conditions
                    </Link>
                  </label>
                </div>

                <button className="submit_btn_input_self">Submit</button>
              </form>
            </div>
          </div>
          <div className="second_interested_section_container">
            <div className="second_img_container">
              <img src={lady_img1} alt="lady_img" />
            </div>
          </div>
        </div>
      </div>
      <AlertCustDialogBox
        dialogHeaderName=""
        open={alertToggleModal}
        onClose={() => {
          setAlertToggleModal(false);
        }}
      >
        <Alertbox />
      </AlertCustDialogBox>
    </section>
  );
}

export default InterestedSectionMain;
